











































































import Vue from 'vue'
import Component from 'vue-class-component'
import { EUserStatus, IUser, IUserChainRole } from '@zunta/configurations'
import { getModule } from 'vuex-module-decorators'
import { UserModule } from '@/store/modules/user.module'
import { PermissionsModule } from '@/store/modules/permissions.module'
import Icon from '@/components/Icon.vue'
import AddAdminModal from '../components/AddAdminModal.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Card from '@/components/Card.vue'
import Table from '@/components/tables/Table.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import StatusUser from '@/components/statuses/StatusUser.vue'
import ButtonDownloadReport from '@/components/ButtonDownloadReport.vue'

@Component({
  name: 'AdminUsers',
  components: {
    ButtonDownloadReport,
    StatusUser,
    Table,
    Card,
    Icon,
    DateTimeLabel,
    AddAdminModal
  }
})
export default class AdminUsers extends Vue {
  permissionsModuleInstance: PermissionsModule = getModule(PermissionsModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  EUserStatus = EUserStatus

  selectedUser: IUser | null = null
  adminModal: boolean = false
  filters: any = {
    limit: 20,
    skip: 0,
    status: EUserStatus.ACTIVE
  }

  get config (): ITableConfig {
    return {
      clearFilterBtn: {
        wrapperClass: 'position-absolute',
        wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
        class: 'rounded-bottom'
      },
      useQuery: true,
      usePagination: true,
      fetchFunction: this.userModuleInstance.getAdminUsersList,
      columns: [
        {
          minWidth: '150px',
          width: 16.6,
          key: 'name',
          searchKey: 'name',
          hasSort: true,
          hasSearch: true,
          label: 'Name',
          type: ETableColumnType.default
        },
        {
          minWidth: '150px',
          width: 16.6,
          key: 'email',
          searchKey: 'email',
          hasSort: true,
          hasSearch: true,
          label: 'Email address',
          type: ETableColumnType.default
        },
        {
          minWidth: '150px',
          width: 10.6,
          key: 'status',
          searchKey: 'status',
          hasSort: true,
          hasSearch: true,
          label: 'Status',
          type: ETableColumnType.select,
          options: [
            {
              key: 'active',
              value: EUserStatus.ACTIVE,
              content: 'Active'
            },
            {
              key: 'inactive',
              value: EUserStatus.NOT_ACTIVE,
              content: 'Inactive'
            }
          ]
        },
        {
          minWidth: '150px',
          width: 10.6,
          key: 'role',
          searchKey: 'role',
          hasSort: true,
          hasSearch: true,
          label: 'User Role',
          type: ETableColumnType.multiselect,
          options: this.userRoleFilters
        },
        {
          minWidth: '120px',
          width: 16.6,
          key: 'createdAt',
          searchKey: 'createdAt',
          hasSort: true,
          hasSearch: true,
          label: 'Date Added',
          type: ETableColumnType.dateRange
        },
        {
          minWidth: '120px',
          width: 12,
          key: 'lastLogin',
          searchKey: 'lastLogin',
          hasSort: true,
          hasSearch: true,
          label: 'Last Login',
          type: ETableColumnType.dateRange
        },
        {
          class: 'text-right',
          minWidth: '100px',
          width: 16.6,
          key: 'actions',
          hasSearch: false
        }
      ]
    }
  }

  get userRoleFilters () {
    return this.userRoles.map((role: IUserChainRole) => ({
      key: role.id.toString(),
      value: role.id.toString(),
      content: role.name
    }))
  }

  get userRoles () {
    return this.$store.state.permissions.roles
  }

  get userList () {
    return this.$store.state.user.users
  }

  get userTotal () {
    return this.$store.state.user.total
  }

  async mounted () {
    await this.permissionsModuleInstance.getAdminRoles()
  }

  openAddAdmin () {
    this.adminModal = true
  }

  closeAddAdmin () {
    this.selectedUser = null
    this.adminModal = false
    // @ts-ignore
    if (this.$refs.table) this.$refs.table.initSearch()
  }

  editUser (user: IUser) {
    this.selectedUser = user
    this.adminModal = true
  }

  async updateStatus (user: IUser) {
    await this.userModuleInstance.updateStatus({
      id: user.id,
      status: user.status === EUserStatus.ACTIVE
        ? EUserStatus.NOT_ACTIVE
        : EUserStatus.ACTIVE
    })
  }
}

